<template>

    <invoice-schedule
        :invoice-schedule-uri="route('api.v1.financial.invoiceschedule.index', false)"
    ></invoice-schedule>

</template>

<script>

import InvoiceSchedule from "../../components/Business/InvoiceSchedule";

export default {

    components: {
        InvoiceSchedule,
    },

    metaInfo: {
        title:'Invoiceschedule',
    },

    name:'FinancialInvoiceschedule',

}

</script>
